import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Winners Mindset';
// Preconnect to third-party origins for faster connection setup
const preconnectOrigins = ['https://fonts.googleapis.com', 'https://fonts.gstatic.com', 'https://www.youtube-nocookie.com', 'https://i.ytimg.com', 'https://img.youtube.com', 'https://api.leadconnectorhq.com', 'https://link.msgsndr.com', 'https://cdn.magicpatterns.com'];
preconnectOrigins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
render(<App data-id="element-1" />, document.getElementById('root'));